import { useCallback, useEffect } from 'react';
import { HqoClientSdk, Handler, SdkEvents } from '@hqo/hqo-miniapp-client-sdk';
import { useMiniappSdk } from 'app/shared/contexts/miniapp-sdk';

export const useMiniappSdkEventHandler = (
  eventName: SdkEvents,
  handler: Handler,
  handlerDependencies: unknown[],
): void => {
  const client = useMiniappSdk() as HqoClientSdk;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const eventHandler = useCallback(handler, handlerDependencies);

  useEffect(() => {
    client?.on(eventName, eventHandler);
  }, [eventName, eventHandler, client]);
};
